import axios from 'axios';

const api = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://service-backend-mejeriforeningen-6ahkf6ex4a-ew.a.run.app'
});

export default api;